<template>
    <div v-if="isVerifyPhone" class="safetyCodeR">
      <div class="header">为保证您的信息安全，需要进行验证</div>
      <div class="phone-input">
        <div class="title">请输入手机号后四位</div>
        <van-password-input
            :value="phone"
            :length="4"
            :focused="showKeyboard"
            @focus="showKeyboard = true"
        />
      </div>
      <van-number-keyboard
          v-model="phone"
          :show="showKeyboard"
          maxlength="4"
          theme="custom"
          extra-key=""
          close-button-text="完成"
          @close="checkPhone"
      />
    </div>
    <layout v-else>
        <div class="row head-title">{{data.hospital_name}}</div>
        <div class="title row">
            <pair label="检查时间" :value="date"></pair>
        </div>
        <div class="row space-between">
            <pair label="姓名" :value="data.hospital_patient_name" />
            <pair label="年龄" :value="age" />
            <pair label="性别" :value="data.hospital_patient_sex" />
        </div>
        <div class="row">
            <pair label="检查部位" :value="data.hospital_check_place" />
        </div>
        <div class="row space-between jc-between">
            <pair label="检查方法" :value="data.hospital_check_method" />
        </div>
        <div class="btns">
          <div class="orange" v-if="!key" @click="showVideo = true">使用帮助</div>
          <div class="orange" v-if="!key" @click="show = true">分享</div>
          <div class="blue" v-if="!key" @click="qrcodeShow1 = true">收藏</div>
        </div>
        <div class="center-btns">
            <div class="btn" @click="linkTo('Reporttxt')">
                <img src="@/assets/limg.png" alt="">
                <span>查看报告</span>
            </div>
          <div v-if="is_open_dicom_processing" class="split"></div>
          <div v-if="is_open_dicom_processing" class="btn" @click="toMovie(true)">
            <img src="@/assets/rimg.png" alt="">
            <span>电子胶片</span>
          </div>
          <div class="split"></div>
          <div class="btn" @click="toMovie(false)">
            <img src="@/assets/rimg.png" alt="">
            <span>{{is_open_dicom_processing?'原始影像':'查看影像'}}</span>
          </div>
        </div>
        <div class="history">
          <button class="blue" :disabled="historyLoading" @click="checkHistory">查看历史报告</button>
          <div class="list">
            <div class="history-item" @click="showReport(item)" v-for="item in historyList" :key="item.hospital_check_time">
              <span class="hospital">{{item.hospital_name}}</span>
              <span class="common-item">
                <span class="item-prop">患者姓名：</span>
                <span class="item-value">{{item.hospital_patient_name}}</span>
              </span>
              <span class="common-item">
                <span class="item-prop">检查类型：</span>
                <span class="item-value">{{item.Modality}}</span>
              </span>
              <span class="common-item">
                <span class="item-prop">检查部位：</span>
                <span class="item-value">{{item.hospital_check_place}}</span>
              </span>
              <span class="common-item">
                <span class="item-prop">检查时间：</span>
                <span class="item-value">{{item.hospital_check_time}}</span>
              </span>
            </div>
          </div>
        </div>
        <popup :show.sync="showVideo">
          <transition name="top">
            <div v-if="showVideo" class="video-c">
              <video controls playsinline src="https://yjpstatic.oos-hesjz.ctyunapi.cn/dzjp.mp4" poster="/poster.png" style="width: 100%;background-color: #2b383e;"></video>
              <div @click="showVideo=false" class="close"></div>
            </div>
          </transition>
        </popup>
        <popup :show.sync="show">
            <transition name="top">
            <div class="share-box" v-show="show">
                <div class="loading" v-show="shareLoading"><van-loading color="#ffffff" size="50"/></div>
                <div class="share-time">
                    <span>分享时效</span>
                    <select v-model="shareHour">
                        <option value="2">2小时</option>
                        <option value="4">4小时</option>
                        <option value="12">12小时</option>
                        <option value="24">1天</option>
                        <option value="72">3天</option>
                    </select>
                </div>
                <div class="share-time">
                    <label>
                        <input type="checkbox" v-model="isEnc">
                        <span>加密分享（输入密码可以浏览查阅）</span>
                    </label>
                </div>
                <div class="share-btns">
                    <div class="btn" @click="show = false">取消</div>
                    <div class="split"></div>
                    <div class="btn" @click="closeShareBox">确定</div>
                </div>
            </div>
            </transition>
        </popup>
        <popup v-if="!showPay" :show.sync="noElectronShow">
          <div v-if="entity_film_print" class="noelectron-box" :class="{'noelectron-box2': canRestore}">
            <div class="close" @click="noElectronShow=false">X</div>
            <div class="text">您已打印塑料胶片<br/>电子胶片功能关闭</div>
            <div v-if="canRestore" @click="toPay" class="btn">
              恢复影像
            </div>
          </div>
          <div v-else class="noelectron-box">
            <div class="close" @click="noElectronShow=false">X</div>
            <div class="text">暂无电子胶片<br/>请查看原始影像</div>
          </div>
        </popup>
        <popup :show.sync="noHistory">
          <div class="noelectron-box" v-show="noHistory">
            <div class="close" @click="noHistory=false">X</div>
            <div class="text">未查询到您的电子胶片历史记录</div>
          </div>
        </popup>
      <popup v-if="!showPay" :show.sync="showTimeExpired">
        <div v-if="timeExpired===1" class="noelectron-box" :class="{'noelectron-box2': canRestore}">
          <div class="close" @click="showTimeExpired=false">X</div>
          <div class="text">您已打印塑料胶片<br/>电子胶片功能关闭</div>
          <div v-if="canRestore" @click="toPay" class="btn">
            恢复影像
          </div>
        </div>
        <div v-if="timeExpired===2" class="noelectron-box noelectron-box2">
          <div class="text">
            您已打印塑料胶片，电子胶片将在{{expireDay?  expireDay + '天' : ''}}{{expireHour?  expireHour + '小时' : ''}}{{expireMinute?  expireMinute + '分钟' : ''}}后关闭。
          </div>
          <div @click="showTimeExpired=false;toMovie(false, true)" class="btn">
            好的
          </div>
        </div>
      </popup>
        <popup :show.sync="isDelete">
          <div class="noelectron-box" v-show="isDelete">
<!--            <div class="close" @click="noHistory=false">X</div>-->
            <div class="text">您已打印塑料胶片<br/>电子胶片功能关闭</div>
          </div>
        </popup>
        <popup :show.sync="isDeleteShow">
        <div class="noelectron-box" v-show="isDeleteShow">
          <div class="close" @click="isDeleteShow=false">X</div>
          <div class="text">正在准备数据<br/>请稍后再试</div>
        </div>
      </popup>
      <popup :show.sync="isErrMsg">
        <div class="errmsg-box" v-show="isErrMsg">
          <div class="text">{{errMsg}}</div>
        </div>
      </popup>
        <popup  bgColor="#172033">
<!--          <div class="noelectron-box">-->
<!--            <div class="phone">-->
<!--              <span class="phone-title">请输入手机号后四位</span>-->
<!--              <span class="phone-input">-->
<!--                <input v-model="phone" maxlength="4" style="width: 70px;" />-->
<!--                <button @click.stop="checkPhone()" style="margin-left: 5px;">验证</button>-->
<!--              </span>-->
<!--              <span>{{phone_msg}}</span>-->
<!--            </div>-->
<!--          </div>-->
        </popup>
        <popup :show="qrcodeShow" bgColor="#172033" opacity="0.88">
            <div class="qrcode-box">
                <!-- <div class="qrcode-head">
                    <div class="qrcode-title">
                        <div class="close" @click="qrcodeShow = false"></div>
                        <div>数字影像</div>
                    </div>
                    <div class="qrcode-right"></div>
                </div> -->
                <div class="qrcode-tip">为了保护您的隐私，请确认对方身份</div>
                <div class="qrcode-content">
                    <div class="qrcode-text" data-text="1">
                        <div class="qrcode-bg" ref="url">{{url}}</div>
                        <div v-show="isEnc">
                            <span>安全码:</span>
                            <span class="red">{{code}}</span>
                        </div>
                        <div>
                            点击<span class="blue" @click="copy" :data-clipboard-text="url">复制</span>以上地址；可以粘贴至浏览器打开或粘贴至微信分享给好友
                        </div>
                    </div>
                    <div class="qrcode-text" data-text="2">
                        <div>有效期为{{shareHour - 0 < 24 ? shareHour + '小时': shareHour / 24 + '天'}}</div>
                    </div>
                    <div class="qrcode-text" data-text="3">
                        <div>请扫描以下二维码</div>
                        <div class="qrcode-img" ref="qrCode"></div>
                        <div class="close" style="margin-left:39%;" @click="qrcodeShow = false"></div>
                    </div>
                </div>
            </div>
        </popup>
        <popup :show="qrcodeShow1" bgColor="#172033" opacity="0.88">
            <div class="qrcode-box qrcode-box1"  >
                <img @click="qrcodeShow1 = false" src="@/assets/Collection.png" alt="">
            </div>
        </popup>
<!--        <template slot="foot">-->
<!--            <div class="blue" @click="checkHistory">查看历史报告</div>-->
<!--        </template>-->
      <template slot="payback">
        <payback v-if="showPay" :pay-item="data" :open-id="openId" @payloading="setPayLoading" @close="closePay"></payback>
      </template>
      <template slot="loading">
        <div class="loading-cover" :style="{display: loading ? 'flex': 'none'}">
          <div class="data-loading-indicator"></div>
          <div class="text">报告加载中</div>
        </div>
        <div class="loading-cover" :style="{display: payLoading ? 'flex': 'none'}">
          <div class="data-loading-indicator"></div>
        </div>
      </template>
    </layout>
</template>

<script>
import data from '@/views/data'
import { Toast } from 'vant';
import QRCode from 'qrcodejs2'
import layout from './layout'
import popup from './pupup'
import payback from './payback';
import Clipboard from 'clipboard';
import { PasswordInput, NumberKeyboard } from 'vant';
import { dicomRecover,getInformation, getHistory, getAccessKey } from "@/api/api";
export default {
    components: {
        layout,
        popup,
        payback,
        'van-password-input': PasswordInput,
        'van-number-keyboard': NumberKeyboard,
        pair: {
            props: {
                label: {type: String, default: ''},
                value: {type: [String, Number], default: ''},
            },
            render () {
                return <div class="pair row-margin0">
                    <span class="label">{this.label}</span>
                    <span class="value">{this.value}</span>
                </div>
            }
        }
    },
    data () {
        return {
            show: false,
            isDeleteShow: false,
            showVideo: false,
            noElectronShow: false,
            showTimeExpired: false,
            showPay: false,
            countIndex: 3,
            expireDay: 0,
            expireHour: 0,
            expireMinute: 0,
            noHistory: false,
            historyLoading: false,
            historyList: [],
            shareHour: 2,
            isEnc: false,
            qrcodeShow: false,
            qrcodeShow1:false,
            url: '',
            showKeyboard: true,
            phone: '',
            phone_msg: '',
            code: '0000',
            shareLoading: false,
            shareKey: '',
            sharePassword: '',
            loading: false,
            payLoading: false,
            isErrMsg: false,
            errMsg: '',
        }
    },
    computed: {
        canRestore() {
          if (this.data && (this.data.id==1476667 || this.data.id==125279) && this.data.is_delete_dicom===0 && this.data.entity_film_print_time) {
            return true
          }
          return false
        },
        timeExpired() {
          console.log('this.data', this.data)

          return 0

          //付费恢复的影像直接看
          if (this.data  && this.data.is_delete_dicom==8) {
            return 0
          }

          //第一中心医院，2023年9月1号之后的，所有MR，不再受是否打印实体胶片限制
          if (this.data.house_id && this.data.house_id.startsWith('dyzx') && this.data.Modality === 'MR' && this.data.hospital_check_time>='2023-09-01') {
            return 0
          }

          if(this.data && this.data.entity_film_print_time && this.data.is_delete_dicom!==9) {
            const diff = 3 * 24 * 60 * 60 * 1000
            const curdiff = new Date().getTime() - new Date(this.data.entity_film_print_time).getTime()
            console.log('curdiff/diff:', curdiff, diff)
            if (curdiff < diff) {
              const n = diff - curdiff
              this.expireDay = Math.floor(n / (24 * 60 * 60 * 1000))
              this.expireHour = Math.floor((n - this.expireDay * 24 * 60 * 60 * 1000) / (60 * 60 * 1000))
              if (this.expireHour===0) {
                this.expireHour = 1
              }
              return 2
            }
            return 1
          }
          return 0
        },
        is_open_dicom_processing () {
          return this.data && this.data.is_open_dicom_processing==1 && this.data.is_delete_dicom!==8 && this.data.is_delete_dicom!==9;
        },
        entity_film_print () {
          return this.data && ((this.data.entity_film_print==1 && this.data.is_delete_dicom!==8 && this.data.is_delete_dicom!==9) || (this.data.is_delete_dicom==1 && this.data.house_id!=='qyzyy' && this.data.house_id!=='qyfy'));
        },
        isVerifyPhone () {
          return !!data.data.needVerifyPhone
        },
        isDelete () {
          return !!data.data.delete_time
        },
        isDeleteDicom () {
          return !!data.data.is_delete_dicom
        },
        openId () {
          return data.open_id
        },
        data () {
            return data.data
        },
        date () {
            return this.data.hospital_check_time ? this.data.hospital_check_time.split(' ')[0] : ''
        },
        age () {
            return this.data.hospital_patient_age ? this.data.hospital_patient_age.split(' ')[0] : ''
        },
        AccessionNumber () {
            return data.AccessionNumber
        },
        phone_key () {
          return data.phone_key
        },
        key () {
            return data.key
        },
        house_id () {
            return data.house_id
        },
        password() {
            return data.password
        }
    },
    methods: {
        setPayLoading(loading) {
          this.payLoading = loading
        },
        toPay() {
          this.showPay=true
          this.showTimeExpired = false
          this.noElectronShow = false
        },
        closePay() {
          this.showPay=false
        },
        showReport(item) {
          let url
          if (item.url && item.url.length) {
            url = item.url
          }else {
            url = `/?AccessionNumber=${item.AccessionNumber}&house_id=${item.house_id}`
            if (this.phone_key) {
              url += `&phone_key=${this.phone_key}`
            }
          }
          window.location = url
        },
        checkPhone() {
          if (!/^\d{4}$/.test(this.phone)) {
            Toast('请输入手机号后四位')
            // this.phone_msg = '请输入手机号后四位'
            return
          }
          getInformation({
            house_id: this.house_id,
            AccessionNumber: this.AccessionNumber,
            last_phone_key: this.phone,
            page: 'index'
          }).then(res => {
            console.warn('res', res)
            if (res.mesaage === '手机号验证失败') {
              Toast(res.mesaage)
              // this.phone_msg = '手机号验证失败'
            } else {
              let url = `/?AccessionNumber=${this.AccessionNumber}&house_id=${this.house_id}&phone_key=${res.data.check_phone_key}`
              window.location = url
            }
          })
        },
        checkHistory() {
          this.historyLoading = true
          getHistory({
            AccessionNumber: this.AccessionNumber,
            house_id: this.house_id,
            check_phone_key: this.phone_key,
            key: this.key,
            password: this.password,

          }).then(res => {
            this.historyLoading = false
            // console.warn('res-history', res)
            if (!res || !res.length){
              this. noHistory = true
            }else{
              this.historyList = res
            }
            // Toast('未查询到您的电子胶片历史记录')
          }).catch(err => {
            this.historyLoading = false
            console.log(err)
          })
        },
        checkDelete(success) {
          if(this.isDeleteDicom) {
            getInformation({
              house_id: this.house_id,
              AccessionNumber: this.AccessionNumber,
              last_phone_key: this.phone,
              page: 'index'
            }).then(res => {
              console.warn('check_is_delete', res)
              if (res.data.is_delete_dicom) {
                this.isDeleteShow = true
                dicomRecover({
                  hospital_id: this.house_id,
                  studyIuid: res.data.StudyInstanceUID
                })
              } else {
                success && success()
              }
            })
          } else {
            success && success()
          }
        },
        toMovie(bElectronMovie, noCheck) {
            if(this.entity_film_print){
              this.noElectronShow = true;
              return;
            }
            if(bElectronMovie && !this.data.is_add_dicom_processing){
              this.noElectronShow = true;
              return;
            }
            console.log('this.timeExpired', this.timeExpired)
            if (!noCheck && this.timeExpired > 0) {
              this.showTimeExpired = true
              // if (this.timeExpired===2) {
              //   const countDown = () => {
              //     if (this.countIndex > 0) {
              //       setTimeout(() => {
              //         this.countIndex--
              //         countDown()
              //       }, 1000)
              //     } else {
              //       data.urrl(bElectronMovie?1:0)
              //       this.showTimeExpired = false
              //       this.countIndex = 3
              //     }
              //   }
              //   countDown()
              // }
              return
            }
            //data.urrl(bElectronMovie?1:0)
            this.checkDelete(() => {
              data.urrl(bElectronMovie?1:0)
            })
        },
        linkTo(path) {
            this.$router.push({path, query: this.$route.query})
        },
        copy() {
            let clipboard = new Clipboard('.blue', {

                // return${this.isEnc}
                text: () =>{
                    let content= ''
                    if(this.isEnc){//如果加密分享有安全码
                        content=`网址:${this.url}\r\n安全码:${this.code}\r\n有效期:${this.shareHour - 0 < 24 ? this.shareHour + '小时': this.shareHour / 24 + '天'}`


                    }else{
                        content=`网址:${this.url}\r\n有效期:${this.shareHour - 0 < 24 ? this.shareHour + '小时': this.shareHour / 24 + '天'}`


                    }
                    return content
                }

            })
            clipboard.on('success', e => {
                Toast('已复制链接')
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                Toast('复制链接失败')
                console.error(e)
                clipboard.destroy()
            })
        },
        creatQrCode(text) {
            this.$refs.qrCode.innerHTML = ''
            let qrcode = new QRCode(this.$refs.qrCode, {
                text,
                width: 200,
                height: 200,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
        },
        closeShareBox() {
            getAccessKey({
                AccessionNumber: this.AccessionNumber,
                valid_time: this.shareHour,
                password: this.isEnc ? '1' : '0'//安全码，1是有安全码
            }).then(res => {
                this.shareLoading = false
                this.shareKey = res.key
                this.code = res.password
                this.show = false
                this.qrcodeShow = true
                let text = window.location.origin
                if (this.isEnc) {
                    text += '/#/safetyCode'
                }
                text += `?key=${res.key}&house_id=${this.house_id}&phone_key=${this.phone_key}`
                this.url = text
                this.creatQrCode(text)
            }).catch(err => {
                console.log(err)
                let code=err.response.data.data.code
                console.log(code)
                console.log(111)
                if(code=== 10001 ) this.$toast('分享过期')
            })
        }
    },
    mounted () {

      this.loading = true
      data.getData(() => {
        console.log('接口调用成功')
        this.loading = false
      }, (err) => {
        this.loading = false
        console.log('err', err)
        const code = err.response.data.data.code
        if (code === 10001) {
          this.isErrMsg = true
          this.errMsg = '分享过期'
        }
      })
    }
}
</script>
